import { ExternalLink } from "lucide-react";
import { ReactNode } from "react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { useEnv } from "@/core/env";

interface ServiceTitanExternalLinkProps {
  url: string;
  children: ReactNode;
}

export const ServiceTitanExternalLink = ({
  url,
  children,
}: ServiceTitanExternalLinkProps) => {
  const { serviceTitanBaseUrl } = useEnv();

  return (
    <a
      href={serviceTitanBaseUrl + url}
      target="_blank"
      rel="noopener noreferrer"
      className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <Stack direction="row" gap="xs" align="center">
        <Typography className="text-primary hover:underline">
          {children}
        </Typography>
        <ExternalLink className="h-4 w-4 text-primary" />
      </Stack>
    </a>
  );
};
